
















































































import Vue, { PropOptions } from 'vue'
import FilterTag from '@/search/components/FilterTag.vue'
import FilterSortOrder from '@/search/components/FilterSortOrder.vue'
import {
  SORT_ORDER, PRINTING_METHOD
} from '@/search/const'

export default Vue.extend({
  components: {
    FilterTag,
    FilterSortOrder
  },
  props: {
    selectedSortOrder:{
      type: String,
      required: true
    },
    tagCategory: {
      type: String,
      required: false,
      default: ''
    },
    tagUnitPrice: {
      type: String,
      required: false,
      default: ''
    },
    tagIndustry: {
      type: Array,
      required: true
    },
    tagPrintingMethod: {
      type: Object,
      required: true
    } as PropOptions<any>,
    tagFacets: {
      type: Array,
      required: true
    } as PropOptions<any>,
    tagEditPatterns: {
      type: Array,
      required: true
    }
  },
  data(): {
    sortOrderItems: Array<{ [key: string]: string }>
  } {
    return {
      sortOrderItems: SORT_ORDER
    }
  },
  computed: {
    showRemoveTags(): string {
      return (
        this.tagCategory ||
        this.tagUnitPrice ||
        this.tagIndustry.length ||
        this.tagPrintingMethod.item ||
        this.tagFacets.length > 0 ||
        this.tagEditPatterns.length > 0
      )
    },
    formatPrintingMethod(): { [key: string]: string }[] {
      return PRINTING_METHOD.filter(
        (item: { [key: string]: string }) => this.tagPrintingMethod.items.includes(item.value)
      )
    }
  },
  methods: {
    activeParamModal() {
      this.$emit('activeParamModal')
    },
    searchSortOrder(value: string) {
      this.$emit('onSearchSortOrder', value)
    }
  }
})
